import { useNavigate } from "react-router-dom";
import { useTheme } from "next-themes";
import { Home, Plus, User, Moon, Sun, Receipt } from "lucide-react";
import {
  CommandDialog, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList,
} from "@/components/ui/command";
import { SpaceAvatar } from "@/components/Avatars";

export const CommandPalette = ({ open, onOpenChange, workspaces, onCreateSpace }) => {
  const navigate = useNavigate();
  const { theme, setTheme } = useTheme();

  const run = (fn) => {
    onOpenChange(false);
    fn();
  };

  return (
    <CommandDialog open={open} onOpenChange={onOpenChange}>
      <CommandInput placeholder="Buscar o ejecutar una acción..." data-testid="command-palette-input" />
      <CommandList data-testid="command-palette-list">
        <CommandEmpty>Sin resultados.</CommandEmpty>
        <CommandGroup heading="Espacios">
          {workspaces.map((ws) => (
            <CommandItem key={ws.id} value={`espacio ${ws.name}`} onSelect={() => run(() => navigate(`/space/${ws.id}`))}>
              <SpaceAvatar icon={ws.icon} color={ws.color} size="sm" />
              <span className="ml-2">{ws.name}</span>
            </CommandItem>
          ))}
        </CommandGroup>
        <CommandGroup heading="Acciones">
          <CommandItem value="inicio home" onSelect={() => run(() => navigate("/"))}>
            <Home className="h-4 w-4 mr-2" /> Ir a Inicio
          </CommandItem>
          <CommandItem value="crear espacio nuevo" onSelect={() => run(onCreateSpace)}>
            <Plus className="h-4 w-4 mr-2" /> Crear Espacio
          </CommandItem>
          {workspaces.length > 0 && (
            <CommandItem value="registrar gasto rapido" onSelect={() => run(() => navigate(`/space/${workspaces[0].id}/expenses?new=1`))}>
              <Receipt className="h-4 w-4 mr-2" /> Registrar gasto
            </CommandItem>
          )}
          <CommandItem value="perfil configuracion" onSelect={() => run(() => navigate("/profile"))}>
            <User className="h-4 w-4 mr-2" /> Mi perfil
          </CommandItem>
          <CommandItem value="tema oscuro claro" onSelect={() => run(() => setTheme(theme === "dark" ? "light" : "dark"))}>
            {theme === "dark" ? <Sun className="h-4 w-4 mr-2" /> : <Moon className="h-4 w-4 mr-2" />}
            Cambiar tema
          </CommandItem>
        </CommandGroup>
      </CommandList>
    </CommandDialog>
  );
};
